import { createFakeApi, createHttpApi, type ApiClient } from '@sciolingo/api-client'
import { API_BASE_URL, API_MODE, AUTH_STRATEGY } from '../shared/config'

/**
 * The adapter selection of §4. `fake` exists for unit tests only — every real
 * build runs against the real API, because a fake cannot produce a server
 * clock, real latency, real CORS or a real failure.
 */
export const api: ApiClient =
  API_MODE === 'fake'
    ? createFakeApi()
    : createHttpApi({
        baseUrl: API_BASE_URL,
        // §13.2 difference 3, behind the one interface it belongs behind.
        credentials: AUTH_STRATEGY === 'cookie' ? 'include' : 'omit',
      })
